<template>
  <v-container>
    <v-btn color="primary" @click="milkTypeAdd()">Yeni Süt Tipi Ekle</v-btn>
    <br />
    <br />

    <v-card>
      <v-card-title>
        Süt tipleri
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="allMilkTypeList"
        :footer-props="{
    'items-per-page-options': [10,25,50,100]
  }"
        :items-per-page="10"
        :search="search"
      >
        <template v-slot:item.active="{ item }">
          <v-checkbox v-model="item.active" @change="milkTypeStatusChange(item)"></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="milkTypeEdit(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MilkTypes",
    data: () => ({
    search: "",
    headers: [
      { text: "Süt tipi", value: "milkType" },
      { text: "Aktif/Pasif", value: "active" },
      { text: "Detay", value: "actions", sortable: false }
    ]
  }),
  computed: mapGetters(["allMilkTypeList"]),
    created() {
    this.getMilkTypes();
  },
  methods: {
    ...mapActions(["getMilkTypes","updateMilkTypeStatus"]),
    //MilkTypeStatusChange
    milkTypeStatusChange(milkType) {
      console.log("milkType", milkType);
      this.updateMilkTypeStatus(milkType).then(response=>{
         console.log("response",response);
         if(response.processStatus=="Success") {
           alert("Güncelleme işlemi başarılıdır");
         }
         else {
           alert("Bir hata oluştu");
         }
       }).catch(err=>{
           alert(err);
       })

    },
    //MilkTypeAdd
    milkTypeAdd() {
      this.$router.push("milkType");
    },
    //Milk Type Detail
    milkTypeEdit(item) {
      this.$router.push(`/dashboard/productCategories/milkType/${item.id}`);
    }
  }
};
</script>

<style>
</style>